import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { packageContent } from 'src/app/constants/billing.const';
import { environment as env } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-upgrade-packages',
  templateUrl: './upgrade-packages.component.html',
  styleUrls: ['./upgrade-packages.component.scss'],
})
export class UpgradePackageComponent implements OnInit {
  switchValue: boolean = false;
  activedPackage: string = 'starter';
  loading: boolean = true;
  agreedToTerms: boolean = false;
  packageContent = packageContent;
  urlTnC: string = env.url_lp_ro + '/terms-condition';

  constructor(private route: Router) {}
  ngOnInit(): void {
    this.agreedToTerms = false;
    this.activedPackage = localStorage.getItem('active_package') || '';
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }
  back() {
    this.route.navigate(['subscriptions']);
  }

  setStyleCard(e: string) {
    if (e !== 'Enterprise') {
      return {
        'border-radius': '20px',
        'background-color': '#f8f8f8',
      };
    } else {
      return {
        'border-radius': '20px',
        background: 'linear-gradient(180deg, #FF6A3A 0%, #CF6A0D 100%)',
        color: 'white',
      };
    }
  }
  setStyleButton(e: string) {
    if (e === 'Starter') {
      return {
        'background-color': '#c2c2c2',
        color: 'white',
      };
    } else if (e === 'Pro') {
      return {
        'background-color': '#f95031',
        color: 'white',
      };
    } else {
      return {
        'background-color': 'white',
        color: '#f95031',
      };
    }
  }
  handleUpgrade(e: string) {
    const packageType = e === 'Pro' ? 'pro' : 'enterprise';
    const queryParams: { duration?: string; package: string } = {
      package: packageType,
    };

    if (this.switchValue === true) {
      queryParams.duration = 'annualy';
    }

    this.route.navigate(['/subscriptions/upgrade-package/choose-package'], {
      queryParams,
    });
  }
  handleSwitch() {
    if (this.switchValue === true) {
      this.packageContent[1].price = '1.520.000,-';
      this.packageContent[1].normalPrice = 'Rp 2.400.000,-';
      this.packageContent[1].saving = '36%';

      this.packageContent[2].price = '2.540.000,-';
      this.packageContent[2].normalPrice = 'Rp 4.800.000,-';
      this.packageContent[2].saving = '47%';
    } else {
      this.packageContent[1].price = '149.000,-';
      this.packageContent[1].normalPrice = 'Rp 200.000,-';
      this.packageContent[1].saving = '25%';

      this.packageContent[2].price = '249.000,-';
      this.packageContent[2].normalPrice = 'Rp 400.000,-';
      this.packageContent[2].saving = '38%';
    }
  }
}
